var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoginPage)?_c('r-header-for-login'):_c('r-header'),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('r-footer',{staticClass:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }